import * as Yup from 'yup';

export default Yup.object().shape({
  hash: Yup.string().min(4, 'Mínimo 4 dígitos').required('Campo obrigatório'),
});
